<template>
  <div class="saomalog-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入二维码编号查找"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer width="50"
            v-model="modal1"
            title="扫码记录"
            :mask-closable="false"
            @on-cancel="modal1 = false">
      <Form label-position="left"
            :label-width="100">
        <Table border
               stripe
               :columns="columsgood"
               :data="datagood"></Table>
      </Form>
    </Drawer>
  </div>
</template>
      
<script>
export default {
  name: "saomalog-list",
  data () {
    return {
      id: null, // 页面agentid
      dataloading: true,
      title: "信息",
      agents: {},
      modal1: false,
      datagood: [],
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "ID",
          key: "id",
          width: 150
        },
        {
          title: "编码号",
          key: "qrcode_num",
          width: 200,
        },
        {
          title: "备注",
          key: "mark",
          width: 200,
        },
        {
          title: "操作",
          key: "action",
          minwidth: 400,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.saomaolog(
                        params.row.id
                      );
                    }
                  }
                },
                "扫码记录"
              ),
            ]);
          }
        }
      ],
      columsgood: [
        {
          title: "昵称",
          minWidth: 350,
          key: "nickname",
          fixed: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "用户名：" + params.row.username
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "昵称：" + params.row.nickname
              ),
            ]);
          }
        },
        {
          title: "扫码时间",
          align: "center",
          key: "created_at",
          width: 150,
        }
      ],
      tablelist: [],
      user_uuid: ""
    };
  },
  created: function () {
    this.user_uuid = this.$route.params.user_uuid;
    this.getTableList();
  },
  components: {
  },
  watch: {
  },
  methods: {
    getTableList: function () {
      this.$api.agents.qrcodes({
        page: this.pages.page,
        size: this.pages.size,
        user_uuid: this.user_uuid
      })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        user_uuid: this.user_uuid
      };
      this.$api.agents.qrcodes(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    saomaolog: function (index) {
      this.modal1 = true;
      this.$api.agents.qrcodeuser({
        id: index
      })
        .then(res => {
          if (res.code == 200) {
            this.datagood = res.result.list;
          }
        });
      return;
    },
  }
};
</script>
      
  
    
  